export default __webpack_public_path__ + "static/media/WAS0100.34I-35512_-20601_0.f0e5a3e0.jpg";